import { QueryParams } from '../apiClient/generated/baseClient';
import { getSessionCurrencyTypeId } from '../cookie';

export function applyCurrencyTypeId(queryParams: QueryParams, endpoint: string) {
  const paperworkEndpoint = 'api/v1/settlement';

  const sessionCurrencyId = getSessionCurrencyTypeId();

  if (!sessionCurrencyId) {
    return queryParams;
  }

  if (endpoint.includes(paperworkEndpoint)) {
    queryParams['q[currency_type_id_eq]'] = sessionCurrencyId;
  } else {
    queryParams.sessionCurrencyId = sessionCurrencyId;
  }

  return queryParams;
}

export function applySessionParams(queryParams: QueryParams, endpoint: string) {
  const params = { ...queryParams };

  applyCurrencyTypeId(params,
    endpoint);

  return params;
}
